import type { TraceEntry } from '../../types';
import { tokens as fmt } from '../../lib/format';
import { absolute } from '../../lib/time';

// La traccia della sessione così come il registro la scrive: chi, quando, cosa, quanto.
export function TraceList({ trace }: { trace: TraceEntry[] }) {
  if (trace.length === 0) {
    return (
      <div className="t-caption faint" style={{ padding: 24, textAlign: 'center' }}>
        Nessuna riga di traccia: i Pops non hanno ancora lavorato su questa sessione.
      </div>
    );
  }
  return (
    <ol
      style={{
        listStyle: 'none',
        margin: 0,
        padding: '16px 20px 32px',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      {trace.map((t) => (
        <li
          key={t.id}
          style={{
            background: 'var(--panel)',
            border: '1px solid var(--border)',
            borderRadius: 'var(--r-md)',
            padding: '8px 12px',
          }}
        >
          <div style={{ display: 'flex', gap: 10, alignItems: 'baseline', marginBottom: 4 }}>
            <span className="t-mono-xs faint">#{t.seq}</span>
            <span className="t-strong">{t.instanceId}</span>
            <span className="t-caption dim">{t.phase ?? t.kind}</span>
            {t.tool && <span className="t-mono-xs dim">{t.tool}</span>}
            <span style={{ flex: 1 }} />
            {t.tokens ? <span className="t-num dim">{fmt(t.tokens)} token</span> : null}
            <span className="t-caption faint">{absolute(t.at)}</span>
          </div>
          <div className="t-small" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {t.text}
          </div>
        </li>
      ))}
    </ol>
  );
}
